<!-- ----------------------------------------------- -->
<template>
  <v-col class="riverwaarm-list pa-0">
    <rw-list></rw-list>
  </v-col>
</template>
<!-- ----------------------------------------------- -->

<script>
import RwList from "../../../components/pc/RwList.vue";
export default {
  components: { RwList },
};
</script>
<style lang="scss" scoped>
.riverwaarm-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  & * + * {
    margin-top: 16px;
  }
}
</style>
